import React from 'react';
import { View } from 'react-native';

import DocumentPreviewSmall from './documentPreviewSmall';
import DocumentPreview from './documentPreview';
import DocumentPreviewMachineList from './documentPreviewMachineList';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';

import ThreeDViewer from './3dViewer/ThreeDViewer';

export default ({
  item,
  small,
  isThumbnail,
  machineList,
  round,
  borderRadius,
  CC,
  alwaysDark,
  fontName,
  scale = initialScale,
  font = initialFont,
  bg,
  withoutDownloadButton,
  withoutFileName,
  width = '100%',
  height = '100%',
  processingContainerStyles,
}) => {
  const renderPreview = () => {
    if (item.isDocument) {
      if (machineList) {
        return (
          <DocumentPreviewMachineList
            {...{ item, borderRadius, CC, alwaysDark, small, fontName, width, height, processingContainerStyles }}
          />
        );
      }

      if (small) {
        return <DocumentPreviewSmall {...{ item, round, borderRadius, CC, alwaysDark, scale, font, fontName, width, height }} />;
      }

      if (item.extensionOriginal === 'glb' && !item.isProcessing) {
        // If add new extension here, add it also into THREE_D_DRAWING_EXTENSIONS_TO_DISPLAY
        return <ThreeDViewer modelUrl={item.downloadUrl} width={width} height={height} />;
      }

      return (
        <DocumentPreview
          {...{
            item,
            borderRadius,
            CC,
            alwaysDark,
            scale,
            font,
            bg,
            withoutDownloadButton,
            withoutFileName,
            fontName,
            width,
            height,
            processingContainerStyles,
          }}
        />
      );
    }

    return <View />;
  };

  return renderPreview();
};
